import React, { useContext } from 'react'

import filterContext from '@/components/pages/production/components/context'
import FilterSheetChip from '@/components/pages/production/components/filters/mobile/components/filter-sheet-chip'
import ticketDetailsContext from '@/components/pages/production/components/ticket-details/context'
import { trackEvent } from '@/utils/analytics/ga360'

interface Props {
    label: string
    quantity: number
}

const QuantityChip: React.FC<Props> = ({ label, quantity }) => {
    const {
        state: filterState,
        dispatch: { onQuantityFilterChangeAction: onFilterChange },
    } = useContext(filterContext)
    const {
        state: detailsState,
        dispatch: { toggleDetails },
    } = useContext(ticketDetailsContext)

    return (
        <FilterSheetChip
            sx={{ flexGrow: 1 }}
            label={label}
            variant={filterState.quantityFilterState.quantity === quantity ? 'filled' : 'outlined'}
            data-testid={'quantity-' + quantity + '-button'}
            onClick={() => {
                if (detailsState.listing) {
                    toggleDetails({ listing: null })
                }

                const newQuantity = filterState.quantityFilterState.quantity === quantity ? 0 : quantity
                onFilterChange({ quantity: newQuantity })
                trackEvent('FilterUse', 'UsedTicketFilters', 'Quantity', undefined, false)
                trackEvent('TicketFilterUse', 'Quantity-FilterModal', `${newQuantity}`, newQuantity, false)
            }}
        />
    )
}

export default QuantityChip
